// personel-takip/src/components/Navbar.js
import "./Navbar.css";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { db } from "../firebaseConfig";
import { collection, query, where, limit, getDocs } from "firebase/firestore";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [ptPerms, setPtPerms] = useState(null);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const normalizedRole = (role || "").toLocaleLowerCase("tr");
  const isCreator = normalizedRole === "oluşturucu";

  // ---------------- FIRESTORE PERMISSIONS OKUMA --------------
  useEffect(() => {
    let cancelled = false;

    (async () => {
      const fromCtx = userPermissions?.personeltakip;
      if (fromCtx) {
        if (!cancelled) setPtPerms(fromCtx);
        return;
      }

      if (!user?.email) {
        if (!cancelled) setPtPerms({});
        return;
      }

      try {
        const q = query(
          collection(db, "users"),
          where("email", "==", user.email.toLowerCase()),
          limit(1)
        );
        const snap = await getDocs(q);
        const perms = snap.empty ? {} : (snap.docs[0].data()?.personeltakip || {});
        if (!cancelled) setPtPerms(perms);
      } catch {
        if (!cancelled) setPtPerms({});
      }
    })();

    return () => { cancelled = true };
  }, [user?.email, userPermissions]);

  // Hamburger
  useEffect(() => {
    const onDown = (e) => {
      if (e.target.closest(".hamburger")) return;
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  const ready = ptPerms !== null;
  const giris = !!ptPerms?.giris;
  const takip = !!ptPerms?.takip;
  const yonetici = !!ptPerms?.yonetici;

  // ---------------- ROL HARITALAMA ----------------
  let isModulAdmin = false;
  let isSahaYonetici = false;
  let isIK = false;
  let isFormen = false;
  let isTakipci = false;

  if (isCreator) {
    // Creator → tüm yetkiler
  } else if (giris && takip && yonetici) {
    isModulAdmin = true;
  } else if (yonetici && !giris && !takip) {
    isSahaYonetici = true;
  } else if (giris && takip && !yonetici) {
    isIK = true;
  } else if (giris && !takip && !yonetici) {
    isFormen = true;
  } else if (!giris && takip && !yonetici) {
    isTakipci = true;             // ✅ YENİ ROL
  }

  // ---------------- SAYFA YETKILERI ----------------
  // 🔴 Değişiklik: Personel Listesi'ni sadece Formen görebilsin.
  const canPersonelListesi = isFormen =
    isCreator || isModulAdmin || isIK || isFormen || isSahaYonetici;

  const canBelgeYukleme =
    isCreator || isModulAdmin || isIK || isFormen || isSahaYonetici;

  const canBelgeYonetimi =
    isCreator || isModulAdmin || isIK || isSahaYonetici;

  const canPuantaj =
    isCreator || isModulAdmin || isIK || isFormen || isSahaYonetici;

  const canKayitlar =
    isCreator || isModulAdmin || isSahaYonetici || isFormen || isTakipci;

  const canKaraListe =
    isCreator || isModulAdmin || isSahaYonetici;

  // ✅ Raporlar → Modüle girebilen HERKES
  const canRaporlar =
    isCreator || isModulAdmin || isIK || isFormen || isSahaYonetici || isTakipci;

  const canMailScheduler = isCreator || isModulAdmin;
  const canAdminPage = isCreator;

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" className="navbar-logo" />
        <span className="navbar-title">Personel Takip Sistemi</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(s => !s)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`} ref={menuRef}>
            {ready && (
              <>
                {canPersonelListesi && (
                  <NavLink className="navbar-link" to="/personel-takip/personel-listesi">Personel Listesi</NavLink>
                )}
                {canBelgeYukleme && (
                  <NavLink className="navbar-link" to="/personel-takip/belge-yukleme">Belge Yükleme</NavLink>
                )}
                {canPuantaj && (
                  <NavLink className="navbar-link" to="/personel-takip/puantaj">Puantaj</NavLink>
                )}
                {canBelgeYonetimi && (
                  <NavLink className="navbar-link" to="/personel-takip/belge-yonetimi">Belge Yönetimi</NavLink>
                )}
                {canKayitlar && (
                  <NavLink className="navbar-link" to="/personel-takip/kayitlar">Takip</NavLink>
                )}
                {canKaraListe && (
                  <NavLink className="navbar-link" to="/personel-takip/kara-liste">Kara Liste</NavLink>
                )}
                {canRaporlar && (
                  <NavLink className="navbar-link" to="/personel-takip/raporlar">Raporlar</NavLink>
                )}
                {canMailScheduler && (
                  <NavLink className="navbar-link" to="/personel-takip/mail-scheduler">MailScheduler</NavLink>
                )}
                {canAdminPage && (
                  <NavLink className="navbar-link" to="/personel-takip/admin">Admin</NavLink>
                )}
              </>
            )}

            <NavLink className="navbar-link" to="/secilen-proje">🔁 Proje Seç</NavLink>

            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
